@if (!schema[SchemaKeywords.UiHide]) {
  @if (schema[SchemaKeywords.UiWidget] || schema.format) {
    <!-- date -->
    @if (schema[SchemaKeywords.UiWidget] === SfoUiWidgetType.DateInput) {
      <sfo-date-input [schema]="schema" [aFormControl]="aFormControl"></sfo-date-input>
    }
    @if (schema[SchemaKeywords.UiWidget] === SfoUiWidgetType.DateVariableInput) {
      <sfo-date-variable-input
        [schema]="schema"
        [aFormControl]="aFormControl | formControl"
        [defaultValue]="defaultValue"
      ></sfo-date-variable-input>
    }
    @if (schema[SchemaKeywords.UiWidget] === SfoUiWidgetType.FontSizeCss) {
      <sfo-font-size-css-input
        [schema]="schema"
        [formControl]="aFormControl"
        [aFormControl]="aFormControl"
      ></sfo-font-size-css-input>
    }

    <!-- rich-text -->
    @if (
      schema[SchemaKeywords.UiWidget] === SfoUiWidgetType.RichText ||
      schema.format === SfoUiWidgetType.RichText
    ) {
      <mat-form-field
        floatLabel="always"
        class="col-12"
        subscriptSizing="dynamic"
      >
        <mat-label>{{ schema.title }}</mat-label>
        <sfo-rich-text-input
          [formControl]="aFormControl"
          (focusEvent)="onFocus()"
          (blurEvent)="onBlur()"
        ></sfo-rich-text-input>
        @if (schema.description) {
          <mat-hint>{{ schema.description }}</mat-hint>
        }
      </mat-form-field>
    }

    <!-- textarea -->
    @if (
      schema[SchemaKeywords.UiWidget] === SfoUiWidgetType.Textarea ||
      schema[SchemaKeywords.UiWidget] === SfoUiWidgetType.CodeEditor ||
      schema.format === 'textarea'
    ) {
      <sfo-textarea
        [schema]="schema"
        [aFormControl]="aFormControl"
        [defaultValue]="defaultValue"
      ></sfo-textarea>
    }

    @if (schema[SchemaKeywords.UiWidget] === SfoUiWidgetType.RadioGroup) {
      <sfo-radio-group-input
        [schema]="schema"
        [aFormControl]="aFormControl"
        [defaultValue]="defaultValue"
      ></sfo-radio-group-input>
    }
  } @else {
    @switch (schema | handleSchemaType) {
      @case ('string') {
        @if (!(schema | hasEnum)) {
          <mat-form-field
            floatLabel="always"
            class="col-12"
            subscriptSizing="dynamic"
            matRipple
          >
            <mat-label>
              {{ schema.title }}
              @if (schema.default && schema.minLength === 0) {
                <ng-container> (Default: {{schema.default || defaultValue}}) </ng-container>
              }
            </mat-label>
            @if (hasStringExamplesAutocomplete) {
              <input
                matInput
                type="text"
                [formControl]="aFormControl"
                [matAutocomplete]="stringExamplesAuto"
                [placeholder]="schema.minLength !== undefined ? '' : (defaultValue || schema.default || '').toString()"
                (focus)="onFocus()"
                (blur)="onBlur()"
              />
              <mat-autocomplete #stringExamplesAuto="matAutocomplete" autoActiveFirstOption>
                @for (option of (filteredStringExampleOptions$ | async); track option.value) {
                  <mat-option [value]="option.value">{{ option.label ?? option.value }}</mat-option>
                }
              </mat-autocomplete>
            } @else {
              <input
                matInput
                type="text"
                [formControl]="aFormControl"
                [placeholder]="schema.minLength !== undefined ? '' : (defaultValue || schema.default || '').toString()"
                (focus)="onFocus()"
                (blur)="onBlur()"
              />
            }

            @if (
              !(aFormControl.value === schema.default || aFormControl.value === defaultValue || aFormControl.value === null) && schema.minLength !== undefined
            ) {
              <button
                matSuffix
                mat-icon-button
                aria-label="Reset to default"
                matTooltip="Reset to default"
                (click)="resetToDefault()"
              >
                <mat-icon>refresh</mat-icon>
              </button>
            }

            <!-- Validation errors -->
            @if (aFormControl.hasError('minlength')) {
              <mat-error> Minimum length is {{ schema['minLength'] }} characters. </mat-error>
            }
            @if (aFormControl.hasError('maxlength')) {
              <mat-error> Maximum length is {{ schema['maxLength'] }} characters. </mat-error>
            }
            @if (aFormControl.hasError('pattern')) {
              <mat-error> Invalid format. Must be a pattern of {{schema['pattern']}} </mat-error>
            }

            @if (schema.description) {
              <mat-hint>
                <span>{{schema.description}}</span>
              </mat-hint>
            }
          </mat-form-field>
        } @else {
          <sfo-enum-input
            [schema]="schema"
            [aFormControl]="aFormControl"
            [defaultValue]="defaultValue"
          ></sfo-enum-input>
        }
      }

      @case ('boolean') {
        <sfo-boolean-input
          [schema]="schema"
          [aFormControl]="aFormControl"
          [defaultValue]="defaultValue"
        ></sfo-boolean-input>
      }

      @case ('integer') {
        <sfo-number-input
          [schema]="schema"
          [aFormControl]="aFormControl"
          [defaultValue]="defaultValue"
        ></sfo-number-input>
      }

      @case ('number') {
        <sfo-number-input
          [schema]="schema"
          [aFormControl]="aFormControl"
          [defaultValue]="schema.default || defaultValue"
        ></sfo-number-input>
      }

      @default {
        <div class="bold red">
          Provided "{{schema | json}}" has an unsupported type: {{schema | handleSchemaType}}.
        </div>
      }
    }
  }
}
